import styled from '@emotion/styled';
import { Button, Drawer, Input, Space, Table, Tooltip } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FaDownload, FaPen, FaPlus, FaUserCheck } from 'react-icons/fa';
import { FiRefreshCcw } from 'react-icons/fi';
import { MdClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import { Layout } from '../../../shared/Layout';
import { ClientForm } from '../../emissionBond/components/ClientForm';
import { KYCForm } from '../../emissionBond/components/KYCForm';
import { getDetenteurs } from '../../emissionBond/network';
import { exportDetenteurData } from '../components/exportDataExcel';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  > .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const ClientPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showDrawer1, setShowDrawer1] = useState(false);
  const [clients, setClients] = useState<DetenteurEntity[]>([]);
  const [filterClients, setFilterClients] = useState<DetenteurEntity[]>([]);
  const [selectedClient, setSelectedClient] = useState<DetenteurEntity>();
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    getDetenteurs(connectedUser.id)
      .then(({ data }) => {
        setClients(data);
        setFilterClients(data);
      })
      .finally(() => setIsLoading(false));
  };

  const search = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterClients(
      clients.filter(
        (cli) =>
          cli.nom.toLowerCase().includes(e.target.value.toLowerCase()) ||
          cli.prenom.toLowerCase().includes(e.target.value.toLowerCase()) ||
          cli.adresse.toLowerCase().includes(e.target.value.toLowerCase()),
      ),
    );
  };

  const COLUMNS = [
    {
      title: 'Code client',
      dataIndex: 'code_referent',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
    },
    {
      title: 'Prénom',
      dataIndex: 'prenom',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Adresse',
      dataIndex: 'adresse',
    },
    {
      title: 'Contact',
      dataIndex: 'mobile',
    },
    {
      title: 'Code Agence',
      render: (cell: any, row: any) => row.agence.code,
    },
    {
      title: 'Agence',
      render: (cell: any, row: any) => row.agence.nom,
    },
    {
      title: 'Gestionnaire',
      render: (cell: any, row: any) =>
        `${row.createur.nom} ${row.createur.prenom}`,
    },
    {
      title: 'Date création',
      dataIndex: 'created_at',
      render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
    },
    {
      title: 'Actions',
      render: (cell: any, row: any) => (
        <Space>
          <Button
            icon={<FaPen style={{ color: 'black', marginBottom: -1 }} />}
            style={{
              backgroundColor: 'transparent',
              borderRadius: 20,
              zoom: 0.8,
              borderColor: PRIMARY,
            }}
            onClick={() => {
              setSelectedClient(row);
              setShowDrawer(true);
            }}
          />
          <Button
            icon={<FaUserCheck style={{ color: 'black', marginBottom: -1 }} />}
            style={{
              backgroundColor: 'transparent',
              borderRadius: 20,
              zoom: 0.8,
              borderColor: PRIMARY,
            }}
            onClick={() => {
              setSelectedClient(row);
              setShowDrawer1(true);
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <div>
            <h2 style={{ marginTop: 20, color: 'white' }}>Liste des clients</h2>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            >
              <Space>
                <Input
                  placeholder='Search...'
                  style={{ width: 250 }}
                  onChange={search}
                />
                <Tooltip title='Rafraichir' placement='top' color={YELLOW}>
                  <span style={{ cursor: 'pointer' }} onClick={fetchData}>
                    <FiRefreshCcw color='black' />
                  </span>
                </Tooltip>
                <PulseLoader
                  size={5}
                  margin={2}
                  color={YELLOW}
                  loading={isLoading}
                />
              </Space>

              <Space>
                <Button
                  icon={<FaPlus style={{ marginBottom: -2, marginRight: 5 }} />}
                  className='butt'
                  style={{ borderRadius: 5 }}
                  onClick={() => {
                    setSelectedClient(undefined);
                    setShowDrawer(true);
                  }}
                >
                  Nouveau client
                </Button>
                <Button
                  icon={
                    <FaDownload style={{ marginBottom: -2, marginRight: 5 }} />
                  }
                  className='butt'
                  style={{ borderRadius: 5 }}
                  onClick={() => exportDetenteurData(clients)}
                >
                  Exporter
                </Button>
              </Space>
            </div>

            <Table
              columns={COLUMNS}
              dataSource={filterClients}
              rowClassName={(row, index) =>
                index % 2 === 0 ? 'even-row' : 'odd-row'
              }
              rowKey='id'
              size='small'
              loading={isLoading}
              style={{ zoom: 0.9 }}
              pagination={false}
              onRow={(row, rowIndex) => {
                return {
                  onClick: (event) => {}, // click row
                  onDoubleClick: (event) => {}, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </div>
        <Drawer
          title='Mettre à jour le client'
          placement='right'
          width={400}
          onClose={() => setShowDrawer(false)}
          open={showDrawer}
          closeIcon={<MdClose size={20} />}
        >
          <ClientForm
            clientToUpdate={selectedClient}
            setShowDrawer={setShowDrawer}
            getNewClient={(cli) => {
              setClients([...clients, cli]);
              setFilterClients([...filterClients, cli]);
            }}
          />
        </Drawer>
        <Drawer
          title='Verifier le KYC'
          placement='right'
          width={400}
          onClose={() => setShowDrawer1(false)}
          open={showDrawer1}
          closeIcon={<MdClose size={20} />}
        >
          <KYCForm
            clientToUpdate={selectedClient}
            setShowDrawer={setShowDrawer1}
            getNewClient={(cli) => {
              setClients([...clients, cli]);
              setFilterClients([...filterClients, cli]);
            }}
          />
        </Drawer>
      </Container>
    </Layout>
  );
};
